<template>
  <div class="constituent-table-wrap">
    <v-table
      :width="tbWidth"
      :columns="columns"
      :table-data="tableData"
      :show-vertical-border="false"
      :show-horizontal-border="false"
      :column-cell-class-name="handelColumnCell"
      :row-click="rowClick"
      :multiple-sort="multipleSort"
      @sort-change="sortChange"
      sort-always
    ></v-table>
    <div class="loading-tip" v-if="loadingFlag === 'loading'">正在加载...</div>
    <div class="loading-tip" v-if="loadingFlag === 'noMore'">无更多数据</div>
  </div>
</template>
<script>
function getStockColor(val, base) {
  let f = val - base
  if(f > 0) return 'rise-color'
  if(f < 0) return 'fall-color'
  return 'draw-color'
}
function getStockUnitNum(num) {
  return num > 0 ? '+' + num : num
}
import { request } from '@/api/request'
import {formatUnit} from '@/utils'

import 'vue-easytable/libs/themes-base/index.css'
import { VTable } from 'vue-easytable'
let marketSZ = require('../../../assets/market_sz.png')
let marketSH = require('../../../assets/market_sh.png')
export default {
  components: { VTable },
  props: {
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      totalSize: 0,
      tdHeight: 30,
      loadingFlag: '',
      multipleSort:false,
      prodCode: '',
      typeCode: '',
      oldHeadCssLeft: '',
      oldHeadCssRight: '',
      pageNo: 1,
      sortFlag: true, // 涨跌幅降序
      timer : null,
      tableData: [],
      scrollCb: null,
      columns: [
          {field: 'stockName',
            formatter: function (rowData,rowIndex,pagingIndex,field) {
              return `<div style="height:50px;line-height:18px;">
                <div>
                <img style="width:15px;" src="${rowData.market === 'SZ' ? marketSZ : marketSH }"/>
                <span style="color:#333;font-size:17px">${rowData.stockName}</span>
                </div>
                <div style="padding-left:18px;color:#999;">${rowData.stockCode}</div>
              </div>`
            },isFrozen: true,title:'股票名称', width: 130, titleAlign: 'left',columnAlign:'left'},
          {field: 'lastPx',
            formatter: function(o){
              let color = getStockColor(o.lastPx, o.preClosePx)
              if(o.lastP == 0) {
                color = 'draw-color'
              }
              return `<span style="font-size: 17px" class="${color}">${o.lastPx ? (o.lastPx/1000).toFixed(2) : '0'}</span>`
            }, title: '最新价', width: 90, titleAlign: 'right',columnAlign:'right'},
          {field: 'pxChangeRate',
            formatter:function(o){
              let color = getStockColor(o.pxChange, 0)
              return `<span style="font-size: 17px" class="${color}">${o.pxChangeRate ? getStockUnitNum((o.pxChangeRate/100).toFixed(2))+'%' : '0.00%'}</span>`
            }, title: '涨跌幅', width: 90, titleAlign: 'right',columnAlign:'right', orderBy:'desc'},
          {field: 'pxChange',
            formatter:function(o) {
              let color = getStockColor(o.pxChange, 0)
              return `<span style="font-size: 17px" class="${color}">${o.pxChange ? getStockUnitNum((o.pxChange/1000).toFixed(2)) : '0'}</span>`
            }, title: '涨跌额',width: 90, titleAlign: 'right',columnAlign:'right'},
          {field: 'preClosePx',
            formatter:function(o){
              return `<span style="font-size: 17px">${o.preClosePx ? (o.preClosePx/1000).toFixed(2) : '0'}</span>`
            }, title:'昨收', width: 90, titleAlign: 'right',columnAlign:'right'},
          {field: 'openPx', 
            formatter:function(o) {
              let color = getStockColor(o.openPx, o.preClosePx)
              return `<span style="font-size: 17px" class="${color}">${o.openPx ? (o.openPx/1000).toFixed(2) : '0'}</span>`
            },title: '今开', width: 90, titleAlign: 'right',columnAlign:'right'},
          {field: 'highPx', 
            formatter:function(o){
              let color = getStockColor(o.highPx, o.preClosePx)
              return `<span style="font-size: 17px" class="${color}">${o.highPx ? (o.highPx/1000).toFixed(2) : '0'}</span>`
            },title: '最高', width: 90, titleAlign: 'right',columnAlign:'right'},
          {field: 'lowPx', 
            formatter:function(o){
              let color = getStockColor(o.lowPx, o.preClosePx)
              return `<span style="font-size: 17px" class="${color}">${o.lowPx ? (o.lowPx/1000).toFixed(2) : '0'}</span>`
            },title: '最低', width: 90, titleAlign: 'right',columnAlign:'right'},
          {field: 'businessAmount',formatter:function(o){
            return `<span style="font-size:17px">${o.businessAmount}</span>`
          }, title:'成交量(手)', width: 90, titleAlign: 'right',columnAlign:'right'},
          {field: 'businessBalance',formatter:function(o){
            return `<span style="font-size:17px">${o.businessBalance}</span>`
          }, title: '成交额', width: 90, titleAlign: 'right',columnAlign:'right'},
      ]
    }
  },
  computed: {
    tbWidth() {
      return document.body.clientWidth
    }
  },
  methods: {
    handleScroll() {
      let _this = this
      let timer = null
      return function(e){
        clearTimeout(timer)
        timer = setTimeout(()=>{
          _this.handleTableHead()
          let isBottom = (document.body.clientHeight - document.documentElement.clientHeight) - document.documentElement.scrollTop < 10
          _this.loadMore(isBottom)
        }, 100)
      }
    },
    setCss(reset){
      let eles = document.querySelectorAll('.v-table-header.v-table-title-class')
      if(reset) {
        eles[0].style.cssText = this.oldHeadCssLeft
        eles[1].style.cssText = this.oldHeadCssRight
      } else {
        eles[0].style.cssText += ';position:fixed;top:0.84rem;background:#fff;' 
        eles[1].style.cssText += ';width:100%;position:fixed;top:0.84rem;left:130px;background:#fff;'
      }
    },
    handleTableHead(e) {// 表格插件吸顶操作
      if(document.getElementById('tabs').getBoundingClientRect().y < 56) {
        this.setCss()
      } else {
        this.setCss(true)
      }
    },
    addScrollListener() {
      document.addEventListener('scroll',this.scrollCb)
    },
    removeScrollListener() {
      document.removeEventListener('scroll',this.scrollCb)
    },
    hanldeData(list) {
      return list.map(o=>{
        return {
          stockCode: o.prodCode,
          stockName: o.prodName,
          market: o.hqTypeCode,
          lastPx: o.lastPx,
          pxChangeRate: o.pxChangeRate,
          pxChange: o.pxChange,
          preClosePx: o.preClosePx,
          openPx: o.openPx,
          highPx: o.highPx,
          lowPx: o.lowPx,
          businessAmount: this.formatUnit(o.businessAmount/100),
          businessBalance: this.formatUnit(o.businessBalance)
        }
      })
    },
    async fetchConsituents(pageNum, sortFlag){
      try {
        let res = await request._get(
          // url: request.apis.quote.constituentList,
          request.apis.quote.blockDetailPart,
          {
            sortFields: 'pxChangeRate',
            hqTypeCode: this.typeCode,
            prodCode: this.prodCode,
            sortFlag: sortFlag,
            pageNum: pageNum,
            pageSize: 20,
            simPageSize: 'yes'
          },
          true,
        )
        this.totalSize = res && res.plate && res.plate.MemberCount || 0
        return this.hanldeData((res && res.sortProdGrp) || {})
      } catch(e) {
        return []
      }
    },
    handelColumnCell() {
      return 'column-height'
    },
    rowClick(rowIndex,rowData){
      this.$router.push({
        path: `/${rowData.market.toLowerCase()}/${rowData.stockCode}.html`
      })
    },
    formatUnit:formatUnit,
    async loadMore(isBottom) {
      if(isBottom && this.pageNo*20<this.totalSize) {
        this.tableData.push(...(await this.fetchConsituents(++this.pageNo, this.sortFlag)))
        this.handleTableHeight()
        return
      } 
      if(isBottom){
        this.loadingFlag = 'noMore'
      }
    },
    async sortChange(params){
      this.sortFlag = params.pxChangeRate === "desc"
      this.pageNo = 1
      this.tableData = await this.fetchConsituents(1,this.sortFlag)
      this.handleTableHeight()
    },
    handleTableHeight(){// 插件高度不是根据内容撑开的会存在滚动条，故每次有数据把高度设置成内容高，关闭纵向滚动，使用根元素滚动
      setTimeout(()=>{
        let cellHeight = this.tdHeight
        let h = this.tableData.length * cellHeight  + 30 + 'px'
        console.log(this.tableData.length, h,cellHeight)
        document.querySelector('.v-table-views').style.height = h
        document.querySelectorAll('.v-table-body')[0].style.height = h
        document.querySelectorAll('.v-table-body')[1].style.height = h
      },1000)
    }
  },
  async created() {
    this.prodCode = this.$route.params.prodCode
    this.typeCode = this.$route.params.typeCode
    this.scrollCb = this.handleScroll()
    this.tableData = await this.fetchConsituents(1,true)
    setTimeout(()=>{
      this.tdHeight = document.querySelector('.v-table-row').clientHeight
      this.loadingFlag = this.totalSize > 20 ? 'loading' : ''
    }, 300)
  },
  mounted() {
    this.oldHeadCssLeft = document.querySelectorAll('.v-table-header.v-table-title-class')[0].style.cssText
    this.oldHeadCssRight = document.querySelectorAll('.v-table-header.v-table-title-class')[1].style.cssText
    this.addScrollListener()
    this.handleTableHeight()
  },
  beforeDestroy(){
    this.removeScrollListener()
  }
}
</script>
<style lang="stylus">
  // easy table 有这个全局样式覆盖其回到初始状态
  *, :after, :before 
    box-sizing initial
  .constituent-table-wrap
    padding-bottom 64px
    .v-table-views
      border none
    .column-height
      height 45px
    .v-table-rightview .v-table-body
      overflow-y hidden
    .v-table-body
      font-weight bold
    .table-title
      color #999
    .v-table-sort-icon i
      color #d8d8d8
    .v-table-sort-icon i.checked
      color #999
    .v-table-sort-icon
      margin-top: 4px;
</style>
<style lang="stylus" scoped>
  .loading-tip
    position: relative;
    top: -5px;
    text-align center
</style>